import http from "./../services/httpService";

// OAuth
export async function startSlackOAuth() {
    const resp = await http.get('/data_sources/slack/oauth/start/')
    return resp.data
}

// Workspaces
export async function getSlackWorkspaces() {
    const resp = await http.get('/slack_workspaces/')
    return resp.data
}

export async function deleteSlackWorkspace(id) {
    const resp = await http.delete(`/slack_workspaces/${id}/`)
    return resp.data
}

export async function refreshSlackChannels(workspaceId) {
    const resp = await http.post(`/slack_workspaces/${workspaceId}/refresh_channels/`)
    return resp.data
}

// Channels
export async function getSlackChannels(params = {}) {
    const queryParams = new URLSearchParams()
    if (params.workspace) queryParams.append('workspace', params.workspace)
    if (params.is_sync_enabled !== undefined) queryParams.append('is_sync_enabled', params.is_sync_enabled)
    if (params.client) queryParams.append('client', params.client)

    const queryString = queryParams.toString()
    const url = queryString ? `/slack_channels/?${queryString}` : '/slack_channels/'
    const resp = await http.get(url)
    return resp.data
}

export async function patchSlackChannel(id, data) {
    const resp = await http.patch(`/slack_channels/${id}/`, data)
    return resp.data
}

export async function triggerSlackChannelSync(channelId) {
    const resp = await http.post(`/slack_channels/${channelId}/trigger_sync/`)
    return resp.data
}
